import { el, mount, unmount } from 'redom';

import './index.scss';

class ApplicationLevelSpinner {

  constructor() {

    this.spinner = el('ht-spinner#application-level-spinner', {
      size: 'small'
    });

  }

  show() {

    mount(document.body, this.spinner);

  }

  hide() {

    unmount(document.body, this.spinner);

  }

}

export default ApplicationLevelSpinner;